/*eslint-disable*/
import { Calculator, IndianRupee, PuzzleIcon, Weight, QrCode, Clock, Timer, Gauge, Users, Boxes, Activity, ScanLine, Percent, Truck, PackageCheck, AlertTriangle, ListChecks, Zap, Pause, RotateCcw } from 'lucide-react';
import overview from '@/Images/overview.svg';
import issued from '@/Images/issued.svg';
import produced from '@/Images/produced.svg';
import primaryPackaged from '@/Images/primaryPack.svg';
import secondaryPackaged from '@/Images/secondaryPack.svg';
import dispatched from '@/Images/externalDispatch.svg';
import wastage from '@/Images/wastage.svg';

export const parentTabs = [
	{
		id: 1,
		header: 'Overview',
		value: 'OVERVIEW',
		icon: overview,
		tableTabs: 'tableTabsOverView',
	},
	{
		id: 2,
		header: 'Issued',
		value: 'ISSUED',
		icon: issued,
		tableTabs: 'tableTabsIssuedSummary',
		tableTabsNaga: 'nagaIssuedSummaryTabs',
	},
	{
		id: 3,
		value: 'PRODUCED',
		header: 'Produced',
		icon: produced,
		tableTabs: 'tableTabsProducedSummary',
		tableTabsNaga: 'nagaProducedSummaryTabs',
	},
	{
		id: 4,
		value: 'PRIMARY_PACKAGING',
		header: 'Primary Packaged',
		icon: primaryPackaged,
		tableTabs: 'tableTabsPackagedSummary',
	},
	{
		id: 5,
		value: 'SECONDARY_PACKAGING',
		header: 'Secondary Packaged',
		icon: secondaryPackaged,
		tableTabs: 'tableTabsSecondaryPackagedSummary',
	},
	{
		id: 6,
		value: 'DISPATCHED',
		header: 'Distribution',
		icon: dispatched,
		tableTabs: 'tableTabsDispatchedSummary',
		tableTabsNaga: 'tableTabsDispatchedSummaryNaga',
	},
	{
		id: 7,
		value: 'WASTAGE',
		header: 'Wastage',
		icon: wastage,
		tableTabs: 'tableTabsWastageSummary',
	}
];
// Planned vs Adhoc split for the Planned-vs-Actual dashboard. "Planned" orders were
// generated from a production plan; "adhoc" ones were raised on their own. Only the
// parent tabs listed in ORDER_SOURCE_PARENT_TABS have this wired on the backend.
export const orderSourceTabs = [
	{ id: 'combined', label: 'All' },
	{ id: 'planned', label: 'Planned' },
	{ id: 'adhoc', label: 'Adhoc' },
];

export const ORDER_SOURCE_PARENT_TABS = ['ISSUED', 'PRIMARY_PACKAGING'];

export const dashboardTabs = [
	{
		id: 'plannedVsActual',
		header: 'Planned vs Actual Dashboard',
	},
	{
		id: 'batchPerformance',
		header: 'Batch Performance Dashboard',
	},
];

export const operationalDataTabs = [
	{
		id: 'inventory',
		header: 'Inventory Data',
		subtitle: 'weight, cost & QR metrics',
	},
	{
		id: 'processAnalysis',
		header: 'Process Data',
		subtitle: 'time & machine utilization',
	},
];
export const meals = [
	{
		id: 55,
		value: 'breakfast',
		header: 'BreakFast',
	},
	{
		id: 56,
		value: 'lunch',
		header: 'Lunch',
	},
	{
		id: 57,
		value: 'snacks',
		header: 'Snacks',
	},
	{
		id: 54,
		value: 'dinner',
		header: 'Dinner',
	},
	{
		id: -999,
		value: 'allDay',
		header: 'All Day',
	},
];


export const processTabsOverview = [
	{ id: 'cycleTime', label: 'Cycle Time', icon: <Clock size={12} /> },
	{ id: 'utilization', label: 'Utilization', icon: <Gauge size={12} /> },
	{ id: 'throughput', label: 'Throughput', icon: <Zap size={12} /> },
];

export const processTabsIssued = [
	{ id: 'kitsCount', label: 'Kits Scanned', icon: <ScanLine size={12} /> },
	{ id: 'measuringTime', label: 'Measuring Time', icon: <Clock size={12} /> },
	{ id: 'perKitTime', label: 'Per Kit Time', icon: <Timer size={12} /> },
	{ id: 'machineUtilisation', label: 'Machine Util.', icon: <Gauge size={12} /> },
];

export const processTabsProduced = [
	{ id: 'productionTime', label: 'Production Time', icon: <Clock size={12} /> },
	{ id: 'perKgTime', label: 'Per Kg Time', icon: <Timer size={12} /> },
	{ id: 'measuringTime', label: 'Measuring Time', icon: <Clock size={12} /> },
	{ id: 'machineUtilisation', label: 'Machine Util.', icon: <Gauge size={12} /> },
	{ id: 'idleTime', label: 'Idle Time', icon: <Pause size={12} /> },
];

export const processTabsPrimaryPackaging = [
	{ id: 'totalFillingTime', label: 'Filling Time', icon: <Clock size={12} /> },
	{ id: 'avgCambroFillingTime', label: 'Avg Fill Time', icon: <Timer size={12} /> },
	{ id: 'cambroCount', label: 'Pkg Count', icon: <Boxes size={12} /> },
	{ id: 'fillAdherance', label: 'Fill Adherence', icon: <Percent size={12} /> },
	{ id: 'machineUtilisation', label: 'Machine Util.', icon: <Gauge size={12} /> },
	// { id: 'fifoAdherence', label: 'FIFO Adherence', icon: <RotateCcw size={12} /> },
];

export const processTabsSecondaryPackaging = [
	{ id: 'totalPkgTime', label: 'Total Pkg Time', icon: <Clock size={12} /> },
	{ id: 'avgPkgTimePerPack', label: 'Avg Pkg Time per Pack', icon: <Timer size={12} /> },
	{ id: 'scanSpeed', label: 'Scan Speed', icon: <Zap size={12} /> },
	{ id: 'labourIdle', label: 'Labour Idle', icon: <Pause size={12} /> },
	// { id: 'fifo', label: 'FIFO', icon: <RotateCcw size={12} /> },
];

export const processTabsDistribution = [
	{ id: 'adherance', label: 'Adherence %', icon: <Percent size={12} /> },
	{ id: 'drTime', label: 'D&R Time', icon: <Clock size={12} /> },
	{ id: 'avgPerHour', label: 'Avg / Hour', icon: <Zap size={12} /> },
	{ id: 'fifoAdherence', label: 'FIFO Adherence', icon: <RotateCcw size={12} /> },
	{ id: 'orderPlacement', label: 'Order Placement Adherence', icon: <ListChecks size={12} /> },
];


export const processTabsByParent = {
	OVERVIEW: processTabsOverview,
	ISSUED: processTabsIssued,
	PRODUCED: processTabsProduced,
	PRIMARY_PACKAGING: processTabsPrimaryPackaging,
	SECONDARY_PACKAGING: processTabsSecondaryPackaging,
	DISPATCHED: processTabsDistribution,
};

export const tabs = [
	{
		id: 'weight', label: 'Weight', icon: <Weight size={12} />,
	},
	{
		id: 'percentage', label: 'Percentage', icon: '%',
	},
	{
		id: 'count', label: 'Count', icon: <Calculator size={12} />
	},
	{
		id: 'cost', label: 'Cost', icon: '₹',
		subTabs: [{
			id: 'totalCost', lable: 'Total Cost', icon: <IndianRupee size={12} />, default: true
		}, {
			id: 'perUnit', lable: 'Per Unit', icon: <PuzzleIcon size={12} />
		}]
	},
	{
		id: 'qrCount', label: 'QR Counts', icon: <QrCode size={12} />
	},
];

export const tableTabsIssuedSummary = [
	{
		id: 1,
		value: 'processWise',
		label: 'Process View',
		processOper: true,
	},
	{
		id: 2,
		value: 'products',
		label: 'Finished Goods View(FG)',
		processOper: true,
	},
	{
		id: 3,
		value: 'rawMaterials',
		label: 'Raw Materials(RM)',
	},
];

export const tableTabsProducedSummary = [
	{
		id: 1,
		value: 'processWise',
		label: 'Process View',
		processOper: true,
	},
	{
		id: 2,
		value: 'outlets',
		label: 'Outlets',
	},
	{
		id: 3,
		value: 'products',
		label: 'Products(FG)',
	},

];
export const tableTabsDispatchedSummary = [
	{
		id: 1,
		value: 'outlets',
		label: 'Outlets',
		processOper: true,
	},
];
export const tableTabsDispatchedSummaryNaga = [
	{
		// Shown first, but only on Process Data → Distribution → D&R Time and never picked as the
		// default tab (see DR_TIME_ONLY_TABS in useTableState).
		id: 3,
		value: 'overview',
		label: 'Overview',
		processOper: true,
	},
	{
		id: 1,
		value: 'outlets',
		label: 'Dispatch View',
		processOper: true,
	},
	{
		id: 2,
		value: 'receive',
		label: 'Receive View',
		processOper: true,
	},
];
export const tableTabsOverView = [
	{
		id: 1,
		value: 'processWise',
		label: 'Process View',
		processOper: true,
	},
	{
		id: 3,
		value: 'intermediate',
		label: 'Intermediates View(SFG)',
		processOper: true,
	},
	{
		id: 2,
		value: 'products',
		label: 'Finished Goods View(FG)',
		processOper: true,
	},
];

export const tableTabsPackagedSummary = [
	{
		id: 1,
		value: 'processWise',
		label: 'Process View',
		processOper: true,
	},
	{
		id: 2,
		value: 'products',
		label: 'Finished Goods View(FG)',
		processOper: true,
		// label: 'Unapacked Goods View',
	},
	// {
	// 	id: 3,
	// 	value: 'batchproduct',
	// 	label: 'Batch Products View(FG)',
	// 	batch: true,
	// 	// label: 'Unapacked Goods View',
	// },
	// {
	// 	id: 3,
	// 	value: 'orderWise',
	// 	label: 'Order View',
	// }
];

export const tableTabsSecondaryPackagedSummary = [
	{
		id: 1,
		value: 'processWise',
		label: 'Process View',
		processOper: true,
	},
	{
		id: 2,
		value: 'products',
		label: 'Finished Goods View(FG)',
		processOper: true,
	},
]

export const tableTabsWastageSummary = [
	{
		id: 1,
		value: 'processWise',
		label: 'Process View',
		processOper: true,
	},
	{
		id: 2,
		value: 'reason',
		label: 'Reason View',
	},
	// {
	// 	id: 3,
	// 	value: 'finishGood',
	// 	label: 'Finished Goods Wise',
	// }
];

export const nagaIssuedSummaryTabs = [
	{
		id: 1,
		value: 'processWise',
		label: 'Process View',
		processOper: true,
	},
	{
		id: 2,
		value: 'products',
		label: 'Finished Goods View(FG)',
		processOper: true,
	},
	{
		id: 3,
		value: 'intermediate',
		label: 'Intermediates View(SFG)',
		processOper: true,
		batch: true,
	},
	{
		id: 4,
		value: 'resturant',
		label: 'Restaurant Indent',
		processOper: true,
		batch: true,
	},
];

export const nagaProducedSummaryTabs = [
	{
		id: 1,
		value: 'processWise',
		label: 'Process View',
		processOper: true,
	},
	{
		id: 3,
		value: 'intermediate',
		label: 'Intermediates View(SFG)',
		processOper: true,
	},
	{
		id: 2,
		value: 'batchintermediate',
		label: 'Batch Intermediate View(SFG)',
		batch: true,
	},
	{
		id: 4,
		value: 'batchProduct',
		label: 'Batch Products View(FG)',
		batch: true,
	},
	// {
	// 	id: 2,
	// 	value: 'products',
	// 	// label: 'Finished Goods View(FG)',
	// 	label: 'Unapacked Goods View',
	// },
];
